// extracted by mini-css-extract-plugin
export default {"toggle":"ToggleSwitch_toggle__ipjzI","slider":"ToggleSwitch_slider__O0wPT"};